export const toCapitalCase = (text: string): string =>
  text.replace(/\b\w/g, (char) => char.toUpperCase());
